var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import classNames from "classnames";
import { merge } from "lodash";
import React, { Component } from "react";
import { buildThemeCssVars, THEME_DEFAULTS } from "./../../ricos-styles";
import {
  AccessibilityListener,
  getLangDir,
  GlobalContext,
  SPOILER_TYPE
} from "./../../wix-rich-content-common";
import viewerStyles from "../statics/rich-content-viewer-scss";
import rtlStyles from "../statics/rtl.rtlignore-scss";
import AddAnchors from "./components/AddAnchors";
import ContentTraverser from "./ContentTraverser";
class ContentViewer extends Component {
  constructor(props) {
    super(props);
    __publicField(this, "styles");
    __publicField(this, "getContextualData", ({
      t,
      theme,
      isMobile = false,
      anchorTarget,
      relValue,
      customAnchorScroll,
      config,
      locale,
      disabled,
      seoMode,
      iframeSandboxDomain,
      textAlignment,
      experiments,
      textDirection,
      direction,
      helpers,
      onNodeClick,
      jsdomMode
    }) => {
      var _a;
      return {
        t,
        theme: theme || {},
        isMobile,
        anchorTarget,
        relValue,
        customAnchorScroll,
        config,
        helpers: helpers || {},
        locale: locale || "en",
        disabled,
        seoMode,
        iframeSandboxDomain,
        disableRightClick: (_a = config == null ? void 0 : config.uiSettings) == null ? void 0 : _a.disableRightClick,
        textAlignment,
        experiments,
        textDirection,
        languageDir: direction || getLangDir(locale),
        onNodeClick,
        jsdomMode
      };
    });
    this.styles = __spreadValues(__spreadValues({}, viewerStyles), rtlStyles);
  }
  render() {
    var _a, _b;
    const {
      config = {},
      onHover,
      isMobile = false,
      addAnchors,
      onMouseOver = () => {
      },
      content,
      setRef,
      typeMappers,
      nodeViewRenderers,
      nodeViewDecorators,
      experiments = {},
      t
    } = this.props;
    const { styles } = this;
    const SpoilerViewerWrapper = (_a = config[SPOILER_TYPE]) == null ? void 0 : _a.SpoilerViewerWrapper;
    const contextualData = this.getContextualData(this.props);
    const viewerClassName = classNames(styles.viewer, {
      [rtlStyles.rtl]: contextualData.textDirection === "rtl"
    });
    const themeWithDefaults = merge(
      {},
      isMobile ? THEME_DEFAULTS.mobile : THEME_DEFAULTS.desktop,
      contextualData.theme
    );
    const style = buildThemeCssVars(themeWithDefaults, (_b = content == null ? void 0 : content.documentStyle) != null ? _b : {});
    const dataId = { "data-id": "content-viewer" };
    return /* @__PURE__ */ React.createElement(GlobalContext.Provider, { key: "RicosViewer", value: { experiments, isMobile, t } }, /* @__PURE__ */ React.createElement(
      "div",
      __spreadValues({
        className: classNames(styles.wrapper),
        dir: contextualData.languageDir,
        onMouseEnter: (e) => onHover && onHover(e),
        onMouseOver,
        ref: setRef,
        style
      }, dataId),
      this.props.devTools,
      /* @__PURE__ */ React.createElement("div", { className: viewerClassName }, /* @__PURE__ */ React.createElement(AddAnchors, { addAnchors }, /* @__PURE__ */ React.createElement(
        ContentTraverser,
        {
          content,
          typeMappers,
          context: contextualData,
          nodeViewRenderers,
          nodeViewDecorators,
          SpoilerViewerWrapper
        }
      ))),
      /* @__PURE__ */ React.createElement(AccessibilityListener, { isMobile })
    ));
  }
}
__publicField(ContentViewer, "defaultProps", {
  theme: {},
  locale: "en",
  config: {}
});
var ContentViewer_default = ContentViewer;
export {
  ContentViewer_default as default
};
//# sourceMappingURL=ContentViewer.js.map
